/* global axios */

const KnowledgeSourcesAPI = {
  getByKnowledgeBase(accountId, knowledgeBaseId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_sources`
    );
  },

  createForKnowledgeBase(accountId, knowledgeBaseId, data) {
    return axios.post(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_sources`,
      data
    );
  },

  updateSource(accountId, knowledgeBaseId, sourceId, data) {
    return axios.patch(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_sources/${sourceId}`,
      data
    );
  },

  deleteSource(accountId, knowledgeBaseId, sourceId) {
    return axios.delete(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_sources/${sourceId}`
    );
  },

  getChunks(accountId, knowledgeBaseId, sourceId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_sources/${sourceId}/knowledge_chunks`
    );
  },

  updateChunk(accountId, knowledgeBaseId, sourceId, chunkId, content) {
    return axios.patch(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_sources/${sourceId}/knowledge_chunks/${chunkId}`,
      { content }
    );
  },

  deleteChunk(accountId, knowledgeBaseId, sourceId, chunkId) {
    return axios.delete(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_sources/${sourceId}/knowledge_chunks/${chunkId}`
    );
  },

  reprocess(accountId, knowledgeBaseId, sourceId) {
    return axios.post(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_sources/${sourceId}/reprocess`
    );
  },

  getInboxes(accountId, knowledgeBaseId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_base_inboxes`
    );
  },

  addInboxes(accountId, knowledgeBaseId, inboxIds) {
    return axios.post(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_base_inboxes`,
      { inbox_ids: inboxIds }
    );
  },

  removeInbox(accountId, knowledgeBaseId, inboxId) {
    return axios.delete(
      `/api/v1/accounts/${accountId}/knowledge_bases/${knowledgeBaseId}/knowledge_base_inboxes/${inboxId}`
    );
  },
};

export default KnowledgeSourcesAPI;
